import { GetterTree } from 'vuex';
import { IHttpState } from './state';

export default {
  isLoading: (state, rootGetters: any) => state.isLoading,
} as GetterTree<IHttpState, any>;
